<tec-modal
    [isVisible]="true"
    [title]="title"
    [tagImage]="modalTagImage"
    [buttonPrimaryLabel]="buttonPrimaryLabel"
    [buttonSecondaryLabel]="buttonSecondaryLabel"
    (closeEvent)="closeModal($event)"
>
    <ng-container body [formGroup]="form">
        <p class="modal-design-theme__intro">{{ 'DESIGN.MODAL_THEME.MODE_INTRO' | translate }}</p>

        <div class="grid grid-i2 modal-design-theme__modes">
            <tec-card-select
                [tagImg]="{ img: 'images/design-theme-light.svg' }"
                [title]="'DESIGN.MODAL_THEME.LIGHT_TITLE' | translate"
                [description]="'DESIGN.MODAL_THEME.LIGHT_DESCRIPTION' | translate"
                [selected]="isModeSelected('light')"
                (selectedChange)="onModeCardChange('light', $event)"
            />
            <tec-card-select
                [tagImg]="{ img: 'images/design-theme-dark.svg' }"
                [title]="'DESIGN.MODAL_THEME.DARK_TITLE' | translate"
                [description]="'DESIGN.MODAL_THEME.DARK_DESCRIPTION' | translate"
                [selected]="isModeSelected('dark')"
                (selectedChange)="onModeCardChange('dark', $event)"
            />
        </div>

        <tec-divider />

        <div class="grid grid-i2">
            <tec-form-group
                [label]="('DESIGN.MODAL_THEME.NAME' | translate) + '*'"
                [errorMsg]="reactiveFormService.hasMsgError(form.get('title'))"
            >
                <tec-input formControlName="title" [hasError]="reactiveFormService.hasError(form.get('title'))" />
            </tec-form-group>

            @if (companyOptions.length > 1) {
                <tec-form-group
                    [label]="('LEGAL_TERMS.FORM.COMPANY' | translate) + '*'"
                    [errorMsg]="reactiveFormService.hasMsgError(form.get('company_uuid'))"
                >
                    <tec-select
                        formControlName="company_uuid"
                        [options]="companyOptions"
                        [search]="true"
                        [hasError]="reactiveFormService.hasError(form.get('company_uuid'))"
                        [placeholder]="'LEGAL_TERMS.FORM.COMPANY_PLACEHOLDER' | translate"
                    />
                </tec-form-group>
            }
        </div>

        @if (showApplyPaletteOption() && isEditMode) {
            <tec-form-group [label]="'DESIGN.MODAL_THEME.APPLY_DEFAULT_PALETTE' | translate">
                <tec-switch formControlName="applyDefaultPaletteOnSkinChange" />
            </tec-form-group>
        }
    </ng-container>
</tec-modal>
